module.exports = __webpack_public_path__ + "img/解决方案背景.194b2c33.png";